
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"20 9 36 36","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.617 29.963h-3.476c.039 1.133.322 1.98.85 2.539.533.56 1.295.84 2.284.84.717 0 1.384-.108 2.002-.322l.274 1.992c-.782.188-1.589.283-2.422.283-1.667 0-2.979-.469-3.936-1.406-.957-.938-1.461-2.246-1.513-3.926H32v-1.377h1.68v-1.25H32v-1.377h1.69c.084-1.66.615-2.95 1.591-3.867.977-.925 2.289-1.387 3.936-1.387.69 0 1.468.101 2.334.303l-.274 2.002a6.237 6.237 0 00-1.982-.332c-.983 0-1.738.28-2.266.84-.527.56-.82 1.373-.879 2.441h3.467v1.377h-3.476v1.25h3.476v1.377z"}})])
          )
        }
      }
    